module.exports = __webpack_public_path__ + "img/52.5f476710.svg";